<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/pay-conditions/table">账期列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="账期名称"
                          prop="name">
              <el-input v-model="form.name" placeholder="请输入账期名称" :disabled="id > 0"></el-input>
            </el-form-item>
            <el-form-item label="金蝶编码"
                          prop="kingdee_number">
              <el-input v-model="form.kingdee_number" placeholder="请输入金蝶编码"></el-input>
            </el-form-item>
            <el-form-item label="到账时间/天"
                          prop="payment_term_days">
            <el-input v-model="form.payment_term_days" placeholder="请输入到账时间,必须为整数"></el-input>
            </el-form-item>
            <el-form-item label="添加附件" prop="attached_file">
            <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-change="(file, fileList) => {onChangeFile(file, fileList, this.form.attached_file)}"
                :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.form.attached_file)}"
                multiple
                :limit="20"
                :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
                :file-list="fileList"
                ref="upload"
                accept=".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .doc, .docx, .xls, .xlsx, .zip"
                >
                <el-button size="small"
                           :loading="fileUploading"
                           element-loading-text="文件上传中……"
                           type="primary">点击上传
                </el-button>
                <div slot="tip"
                     class="el-upload__tip">请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button @click="$router.back()">取消</el-button>
          <el-button type="primary"
                     :disabled="fileUploading"
                     native-type="submit">保存
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../pay-conditions.rules.js'

export default {
  components: {},
  data () {
    return {
      id: 0,
      fileUploading: false,
      formRules,
      fileList: [],
      form: {
        name: '',
        kingdee_number: '',
        payment_term_days: null,
        attached_file: [],
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getPayCondition', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
        this.fileList = data.attached_file
      })
    },
    getForm () {
      let formCopied = filter.copyJson(this.form)
      formCopied.attached_file = formCopied.attached_file.map(item => {
        return {name: item.name, url: item.url, type: item.type}
      })
      return formCopied
    },
    onSubmit () {
      this.$refs['form'].validate((valid, object) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          const reasons = object ? Object.keys(object).map(key => object[key][0].message).join('；') : ''
          this.$message.error('提交内容填写不正确！' + (reasons ? '原因：' + reasons : ''))
        }
      })
    },
    create () {
      request.common('createPayCondition', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.onReload()
        }, () => {
          this.$router.push({path: '/pay-conditions/table/'})
        })
      })
    },
    update (id) {
      request.common('updatePayCondition', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/pay-conditions/table/'})
        })
      })
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onChangeFile (file, fileList, formField) {
      let isLt5M = file.raw.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.$message.error('文件内容必须小于5MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      this.fileUploading = true
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadPayConditionFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml' || (file.name.substr(-5).toLowerCase() === '.html') || (file.name.substr(-4).toLowerCase() === '.htm')) {
          type = 'eml'
        } else if (file.name.substr(-5).toLowerCase() === '.docx' || (file.name.substr(-5).toLowerCase() === '.xlsx') || (file.name.substr(-4).toLowerCase() === '.doc')) {
          type = 'office'
        } else if (file.name.substr(-4).toLowerCase() === '.zip') {
          type = 'zip'
        }
        if (index > -1) {
          formField[index] = {name: file.name, url: data, type: type}
        }
        this.fileUploading = false
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
        this.fileUploading = false
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/pay-conditions/pages/PayConditionsForm.vue